// extracted by mini-css-extract-plugin
export var columnList = "_fn-0";